import React from 'react';

const ButtonGroupContext = React.createContext(null);

export default ButtonGroupContext;



// WEBPACK FOOTER //
// ./src/lib/ButtonGroupContext/index.js